import { Controller } from '@hotwired/stimulus'
import * as WebAuthnJSON from '@github/webauthn-json'

export default class extends Controller {
  static values  = { callbackUrl: String }

  create(event) {
    if (!event.detail.success) {
      console.log(event.detail.error?.message)
      return
    }

    event.detail.fetchResponse.response.json().then(publicKey => {
      WebAuthnJSON.create({ 'publicKey': publicKey })
        .then(credential => this.#callback(credential))
        .catch(error => console.log(error))
    })
  }

  #callback(credential) {
    fetch(this.callbackUrlValue, {
      method: 'PUT',
      headers: {
        'X-CSRF-Token': document.querySelector("[name='csrf-token']").content,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ credential: credential })
    }).then(response => response.text())
      .then((data) => {
        Turbo.renderStreamMessage(data)
      })
  }
}